var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"mall-left"},_vm._l((_vm.list),function(item){return _c('p',{key:item.id,staticClass:"item f-hide",class:{'active': _vm.currentItem == item.id},on:{"click":function($event){return _vm.selectFn(item)}}},[_vm._v(_vm._s(item.dictName))])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }